// extracted by mini-css-extract-plugin
export default {"minus-button":"styles__minus-button--vHHoc","plus-button":"styles__plus-button--Sf7TB","input-with-buttons-on-right":"styles__input-with-buttons-on-right--ajUx9"};